import axios from 'axios';

import type {
	GscLimitResponse,
	RateFileOutputFormatsResponse,
	SettingsConfigurationResponse,
	SettingsConfigurationUpdateInput,
	StateLimitResponse,
} from 'src/interfaces/Configuration';

function createApiUri(path: string = '') {
	return '/api/gtdcm/v1/configuration' + path;
}

export const fetchConfigurationUri = createApiUri();
export async function fetchConfiguration() {
	const response = await axios.get<SettingsConfigurationResponse>(
		fetchConfigurationUri
	);

	return response.data.data;
}

export const updateConfigurationUri = createApiUri();
export async function updateConfiguration(
	update: SettingsConfigurationUpdateInput
) {
	const response = await axios.put<SettingsConfigurationResponse>(
		updateConfigurationUri,
		update
	);

	return response.data.data;
}

export const fetchOutputFormatsUri = createApiUri('/output-types');
export async function fetchOutputFormats() {
	const response = await axios.get<RateFileOutputFormatsResponse>(
		fetchOutputFormatsUri
	);

	return response.data.data;
}

export const fetchAllOutputFormatsUri = createApiUri('/output-types/all');
export async function fetchAllOutputFormats() {
	const response = await axios.get<RateFileOutputFormatsResponse>(
		fetchAllOutputFormatsUri
	);

	return response.data.data;
}

export const fetchStateLimitUri = createApiUri('/state-limit');
export async function fetchStateLimit() {
	const response = await axios.get<StateLimitResponse>(fetchStateLimitUri);

	return response.data.data;
}

export const fetchGscLimitUri = createApiUri('/gsc-limit');
export async function fetchGscLimit() {
	const response = await axios.get<GscLimitResponse>(fetchStateLimitUri);

	return response.data.data;
}
